module.exports = __webpack_public_path__ + "static/img/consultingCenter_2.d54c9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultingCenter_2.png
// module id = hc7Z
// module chunks = 1